import _asyncToGenerator from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/app/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import * as React from 'react';
import { useMCreateWaiterOrder } from '~graphql/generated/clientGraphql';
import { useAuthCtx } from '~logic/auth/AuthProvider';
import { getHandoverType } from '../ResolvedCompanyContext/getHandoverType';
import { useResolvedCompanyCtx } from '../ResolvedCompanyContext/ResolvedCompanyProvider';
import { useOrderIdCtx } from './OrderProvider';
export var useCreateOrder = function useCreateOrder() {
  var _useAuthCtx = useAuthCtx(),
      userToken = _useAuthCtx.userToken;

  var refHasError = React.useRef(false);
  var resolvedCompany = useResolvedCompanyCtx();

  var _useOrderIdCtx = useOrderIdCtx(),
      orderId = _useOrderIdCtx.orderId,
      initializeOrder = _useOrderIdCtx.initializeOrder,
      isOrderInitialized = _useOrderIdCtx.isOrderInitialized,
      isLoadingPersistence = _useOrderIdCtx.isLoadingPersistence,
      clearOrder = _useOrderIdCtx.clearOrder;

  var branchId = resolvedCompany.resolvedBranch.id;
  var sector = resolvedCompany.sector;

  var _useMCreateWaiterOrde = useMCreateWaiterOrder(),
      _useMCreateWaiterOrde2 = _slicedToArray(_useMCreateWaiterOrde, 1),
      mCreateOrder = _useMCreateWaiterOrde2[0];

  var variables = React.useMemo(function () {
    var _sector$warePriceType, _sector$warePriceType2, _sector$id;

    return {
      branchId: branchId,
      priceType: (_sector$warePriceType = sector === null || sector === void 0 ? void 0 : (_sector$warePriceType2 = sector.warePriceType) === null || _sector$warePriceType2 === void 0 ? void 0 : _sector$warePriceType2["enum"]) !== null && _sector$warePriceType !== void 0 ? _sector$warePriceType : "DELIVERY",
      deliveryType: getHandoverType({
        sector: sector
      }),
      sectorId: (_sector$id = sector === null || sector === void 0 ? void 0 : sector.id) !== null && _sector$id !== void 0 ? _sector$id : null
    };
  }, [branchId, sector]);
  var createOrderMutation = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", mCreateOrder({
              variables: variables
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [mCreateOrder, variables]);
  React.useEffect(function () {
    var createOrder = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _yield$createOrderMut, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!refHasError.current) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (!isLoadingPersistence) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                if (!isOrderInitialized) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return");

              case 6:
                _context2.next = 8;
                return createOrderMutation();

              case 8:
                _yield$createOrderMut = _context2.sent;
                data = _yield$createOrderMut.data;

                if (data) {
                  _context2.next = 14;
                  break;
                }

                refHasError.current = true;
                initializeOrder();
                return _context2.abrupt("return");

              case 14:
                // use newly created orderId and store it in the persistence
                initializeOrder({
                  id: data.order.id,
                  userToken: userToken
                });

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function createOrder() {
        return _ref2.apply(this, arguments);
      };
    }();

    createOrder();
    return function () {
      // if the orderId wasn't created (e.g. closed branch),
      // reset the order initialization (in the OrderProvider) when leaving the menu screen,
      // to enable the next attempt to create the orderId with different menu params (e.g. different branch, that is open)
      // we use `clearOrder` to reset the initialization (despite unnecessary reset of the persistence), to keep things simple
      if (orderId === null && isOrderInitialized) {
        clearOrder();
      }
    };
  }, [orderId, branchId, initializeOrder, isOrderInitialized, isLoadingPersistence, clearOrder, userToken, mCreateOrder, createOrderMutation]);
  return orderId !== null && orderId !== void 0 ? orderId : null;
};